export default "./dist/stdassets/images/icons/pan-east.png";